import { handleError, handleSuccess, triggerGet, triggerPost } from './utils';
const getProviderToken = async providerId => {
  const apiResponse = await triggerGet("/business/providers/auth/".concat(providerId));
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData, false);
  }
  return handleError(responseData);
};
const forgotPasswordApiRequest = async data => {
  const apiResponse = await triggerPost("/user/account/forgot", data, false);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const resetPasswordApiReqeust = async data => {
  const apiResponse = await triggerPost("/user/account/reset/", data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
export { getProviderToken, forgotPasswordApiRequest, resetPasswordApiReqeust };